import React from "react";


const ViewImages = () => {


    return (
        <div>


            <h1>From server</h1>

            <img src="/image1/img1.png" style={{ maxWidth: "100%", display: "block" }} />
            <p>1</p>
            <img src="/image1/img2.png" style={{ maxWidth: "100%", display: "block" }} />
            <p>2</p>
            <img src="/image1/img3.png" style={{ maxWidth: "100%", display: "block" }} />
            <p>3</p>
            <img src="/image1/img4.png" style={{ maxWidth: "100%", display: "block" }} />
            <p>4</p>
            <img src="/image1/img5.png" style={{ maxWidth: "100%", display: "block" }} />
            <p>5</p>
            <img src="/image1/img6.png" style={{ maxWidth: "100%", display: "block" }} />
            <p>6</p>



            <br></br><br></br><br></br>

        </div>

    );
};

export default ViewImages;